import React from "react";
import { Grid, Typography, Box, Paper } from "@material-ui/core";
import rest from "../../rest";
import getUserAgentInfo from "../../components/general/userAgent";
import ButtonConfirm from "../../components/general/ButtonConfirm";
import DeleteIcon from "@material-ui/icons/Delete";
import ButtonStyled from "../../components/general/ButtonStyled";

// Fonction utilitaire pour convertir la durée en format HH:MM
const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

const formatDate = (dateString) => {
  // Convertir la chaîne en objet Date
  const [day, month, year] = dateString.split(".");
  const date = new Date(`${year}-${month}-${day}`);

  // Formater la date selon la locale "fr-FR"
  return date.toLocaleDateString("fr-FR", {
    weekday: "short", // jour abrégé (jeu.)
    day: "numeric", // jour du mois
    month: "short", // mois abrégé (déc.)
    year: "numeric", // année complète
  });
};

// Grouper les activités par nom d'activité et date
const groupByActivityAndDate = (data) => {
  return data.reduce((acc, item) => {
    if (!acc[item.NomActivite]) {
      acc[item.NomActivite] = {};
    }
    if (!acc[item.NomActivite][item.DateActivite]) {
      acc[item.NomActivite][item.DateActivite] = [];
    }
    acc[item.NomActivite][item.DateActivite].push(item);
    return acc;
  }, {});
};

const ActivitiesDisplay = ({
  activities,
  setRefresh,
  setSnack,
  manifParams,
}) => {
  // Grouper les activités par nom et date
  const groupedActivities = groupByActivityAndDate(activities);

  const handleDesinscription = (id) => {
    let params = {
      vId: id,
      info: JSON.stringify(getUserAgentInfo()),
    };
    rest
      .post("/benevols/activiteInscription.json", params)
      .then(function (response) {
        if (response.data.Msg === "nok") {
          setSnack({
            message: response.data.textMsg,
            show: true,
            severity: "error",
          });
        } else {
          setSnack({
            message: response.data.textMsg,
            show: true,
            severity: "success",
          });
          setRefresh((prev) => !prev);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const isOptionWish = manifParams.manifParams.InscripionWishlist;

  return (
    <Paper
      style={{
        width: "100%",
        boxSizing: "border-box",
        padding: "30px",
        marginBottom: "20px",
      }}
    >
      {Object.keys(groupedActivities).map((activityName, index) => (
        <Grid container key={activityName} alignItems="center" spacing={1}>
          <Grid item xs={12}>
            <Box>
              <Typography
                variant="h5"
                style={{
                  marginBottom: 10,
                  fontWeight: "bold",
                  paddingTop: 8,
                  marginLeft: 8,
                  fontSize: 20,
                }}
              >
                {activityName}
              </Typography>
            </Box>
          </Grid>

          {Object.keys(groupedActivities[activityName]).map((activityDate) => (
            <Grid
              container
              key={activityDate}
              spacing={0}
              style={{ flexWrap: "wrap" }}
            >
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  style={{ fontWeight: "bold", fontSize: 16, margin: 10 }}
                >
                  {formatDate(activityDate)}
                </Typography>
              </Grid>

              {groupedActivities[activityName][activityDate].map(
                (activity, i) => (
                  <Grid
                    item
                    xs={6}
                    md={3}
                    style={{
                      margin: "0",
                      padding: "5px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "7px",
                      border: "4px solid rgba(255, 255, 255,1)",
                      boxSizing: "border-box",
                      width: "calc(100% - 12px)",
                    }}
                    key={i}
                  >
                    <Typography
                      variant="body2"
                      style={{ fontSize: 14, fontWeight: "bold" }}
                    >
                      {activity.HeureActivite}
                    </Typography>

                    <Typography variant="body2" style={{ fontSize: 12 }}>
                      Responsable: {activity.Responsable} (
                      {formatDuration(activity.vNombreHeure)} h)
                    </Typography>
                    {!isOptionWish &&
                      (activity.statut !== 2 ? (
                        <ButtonConfirm
                          onConfirm={() => {
                            handleDesinscription(activity.ActTrancheId);
                          }}
                          text=""
                          textConfirm={"Confirmer supprimer cette horaire"}
                          variant="contained"
                          color="successDarkBtn"
                          style={{ marginRight: 10 }}
                          icon={<DeleteIcon />}
                          position={"left-end"}
                        />
                      ) : (
                        <ButtonStyled
                          variant="contained"
                          size="small"
                          disabled={true}
                        >
                          Activité terminé{" "}
                        </ButtonStyled>
                      ))}
                  </Grid>
                )
              )}
            </Grid>
          ))}
        </Grid>
      ))}
    </Paper>
  );
};

export default ActivitiesDisplay;
